import moment from "moment";
const datenow = moment().format("YYYY-MM-DD");

export const ValCart = async (data, type, isMobile, isProduct) => {
  const errors = [];
  if (type === "order" && !isMobile) {
    if (!data.tgl_pemeriksaan && isProduct) {
      errors.push({ type: "date", message: "tanggal tidak boleh kosong" });
    } else if (data.tgl_pemeriksaan) {
      const isSunday = moment(data.tgl_pemeriksaan).day();

      if (!moment(data.tgl_pemeriksaan.toString()).isAfter(datenow, "day")) {
        if (!moment(data.tgl_pemeriksaan.toString()).isSame(datenow, "day"))
          errors.push({
            type: "date",
            message: "tidak boleh memilih hari kemarin",
          });
      } else if (isSunday === 0) {
        errors.push({
          type: "date",
          message: "tidak boleh memilih hari minggu",
        });
      }
    }

    if (data.info !== 3 && !data.jam_pemeriksaan) {
      errors.push({ type: "time", message: "jam tidak boleh kosong" });
    } else if (data.info !== 3 && data.jam_pemeriksaan) {
      const startTime = moment("07:00", "hh:mm");
      const endTime = moment("17:00", "hh:mm");
      const dataTime = moment(data.jam_pemeriksaan, "hh:mm");
      if (dataTime.isBefore(startTime)) {
        errors.push({ type: "time", message: "jam operasional 07:00 - 17:00" });
      } else if (dataTime.isAfter(endTime)) {
        errors.push({
          type: "time",
          message: "jam operasional 07:00 - 17:00",
        });
      }
    }
  } else if (type === "cart" && !isMobile) {
    if (data.name === "tgl_pemeriksaan" && !data.value) {
      errors.push({ type: "date", message: "tanggal tidak boleh kosong" });
    } else if (data.name === "tgl_pemeriksaan" && data.value) {
      const isSunday = moment(data.value).day();
      if (!moment(data.value.toString()).isAfter(datenow, "day")) {
        if (!moment(data.value.toString()).isSame(datenow, "day"))
          errors.push({
            type: "date",
            message: "tidak boleh memilih hari kemarin",
          });
      } else if (isSunday === 0) {
        errors.push({
          type: "date",
          message: "tidak boleh memilih hari minggu",
        });
      }
    }

    if (data.name === "jam_pemeriksaan" && !data.value) {
      errors.push({ type: "time", message: "jam tidak boleh kosong" });
    } else if (data.name === "jam_pemeriksaan" && data.value) {
      const startTime = moment("07:00", "hh:mm");
      const endTime = moment("17:00", "hh:mm");
      const dataTime = moment(data.value, "hh:mm");

      if (dataTime.isBefore(startTime)) {
        errors.push({ type: "time", message: "jam operasional 07:00 - 17:00" });
      } else if (dataTime.isAfter(endTime)) {
        errors.push({
          type: "time",
          message: "jam operasional 07:00 - 17:00",
        });
      }
    }
  }

  return errors;
};
